import React, { useEffect, useState } from 'react';
import styles from '../../formStyles.module.css';
import FormItem from '@/components/common/FormItem';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import Api from '@/api';

export default function AddSubuserInfo({ info, setInfo, modalKey, onKeyDown }) {
  const tCommon = useTranslations('common');
  let formarray = [
    {
      id: 1,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: '7' + '******' + '0912',
      title: tCommon('mobile'),
      error: info?.messages?.mobile,
      // extraInfo: ' * ',
      // styleColor: `starColor`,
      showError: info?.error?.mobile,
      value: info?.mobile,
      key: 'mobile',
      // wrapper: `darkInput`,
      onKeyDown: onKeyDown,
      inputType: 'number',
    },
    {
      id: 2,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: tCommon('nationalCode'),
      title: tCommon('nationalCode'),
      error: info?.messages?.nationalCode,
      value: info?.nationalCode,
      showError: info?.error?.nationalCode,
      error: info?.messages?.nationalCode,
      key: 'nationalCode',
      // wrapper: `darkInput`,
      onKeyDown: onKeyDown,
      inputType: 'number',
    },
  ];

  const [formList, setFormList] = useState(formarray);

  useEffect(() => {
    if (info) {
      setFormList(formarray);
    }
  }, [info]);

  const onChange = (value, key) => {
    let valueIs = {
      ...info,
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };
    if (key == 'mobile') {
      valueIs.mobile = valueIs?.mobile?.startsWith('0')
        ? valueIs?.mobile.slice(1)
        : valueIs?.mobile;
    }
    if (key == 'country') {
      valueIs.province = null;
      valueIs.city = null;
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }
    if (key == 'province') {
      valueIs.city = null;
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }
    if (key == 'city') {
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }

    setInfo(valueIs);
  };

  console.log('info==', info);

  return (
    <div className={`${styles.formContainer} mt-0`}>
      {formList?.map((item, index) => (
        <FormItem
          type={item.type}
          inputType={item.inputType}
          key={index}
          item={item}
          index={index}
          onChange={onChange}
          value={info?.[`${item?.key}`]}
        ></FormItem>
      ))}
    </div>
  );
}
